import { render, staticRenderFns } from "./UserSubmitMissingDocuments.vue?vue&type=template&id=102ab1b6&scoped=true&"
import script from "./UserSubmitMissingDocuments.vue?vue&type=script&lang=js&"
export * from "./UserSubmitMissingDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UserSubmitMissingDocuments.vue?vue&type=style&index=0&id=102ab1b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102ab1b6",
  null
  
)

export default component.exports